export default __webpack_public_path__ + "static/media/NodeJs.31574668.png";